import { PatchResourcesBody } from '../types';
import axios from '../../../services/axios';

const BASE_API_URL = import.meta.env.VITE_APP_API_URL;

export const patchOperations = async (body: PatchResourcesBody, org_id: string) => {
  try {
    const response = await axios.post(`${BASE_API_URL}/valet/v2/operation-data-mapping`, body, {
      params: { org_id },
    });

    return response.data;
  } catch (err: any) {
    return err;
  }
};
